/* eslint-disable */
import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import { LogoutSuccess } from '@myStore/auth/auth.actions';
import { ITokens } from '@myStore/auth/auth.state';
import { Store } from '@ngrx/store';
import { AuthService } from '@services/auth/auth.service';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  refreshTokenInProgress = false;

  tokenRefreshedSource = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

  constructor(
    private _store: Store<IAppState>,
    private _authService: AuthService,
    private _dialog: MatDialog,
    private _router: Router
  ) {}

  addAuthHeader(request: any) {
    const authHeader = this._authService.getToken('access');
    if (authHeader) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${authHeader}`,
        },
      });
    }

    return request;
  }

  refreshToken(): Observable<any> {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;

      return this._authService.refreshToken().pipe(
        tap((userTokens: ITokens): any => {
          this._authService.updateTokens(userTokens);
          this.refreshTokenInProgress = false;
          this.tokenRefreshedSource.next();
        })
      );
    }
  }

  handleResponseError(error: any, request?: any, next?: any): any {
    if (error.status === 401) {
      if (error.url === environment.baseUrl + 'api/v1/users/refresh-token/') {
        this.refreshTokenInProgress = false;
        this._dialog.closeAll();
        this._store.dispatch(new LogoutSuccess());
        return throwError(error);
      }

      if (error.url === environment.baseUrl + 'api/v1/users/sign-in/') {
        this.refreshTokenInProgress = false;
        return throwError(error);
      }

      return this.refreshToken().pipe(
        switchMap(() => {
          request = this.addAuthHeader(request);
          return next.handle(request);
        })
      );
    }

    if (
      error.status === 400 &&
      error.url === environment.baseUrl + 'api/v1/users/refresh-token/'
    ) {
      this.refreshTokenInProgress = false;
      this._store.dispatch(new LogoutSuccess());
      return throwError(error);
    }

    if (
      error.status === 404 &&
      !error.url.startsWith(environment.baseUrl + 'api/v1/s3-files/')
    ) {
      return this._router.navigate(['/profile']);
    }

    return throwError(error);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
    request = this.addAuthHeader(request);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleResponseError(error, request, next);
      })
    );
  }
}
